import { render, staticRenderFns } from "./Specifications.vue?vue&type=template&id=704d3cb2&scoped=true"
import script from "./Specifications.vue?vue&type=script&lang=js"
export * from "./Specifications.vue?vue&type=script&lang=js"
import style0 from "./Specifications.vue?vue&type=style&index=0&id=704d3cb2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704d3cb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('704d3cb2')) {
      api.createRecord('704d3cb2', component.options)
    } else {
      api.reload('704d3cb2', component.options)
    }
    module.hot.accept("./Specifications.vue?vue&type=template&id=704d3cb2&scoped=true", function () {
      api.rerender('704d3cb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TradeWatcher/Specifications.vue"
export default component.exports